/* ss-widget.js — il pulsante WhatsApp resta un pallino verde e sparisce
   quando il carrello e' aperto, altrimenti copre "Vai al pagamento". */
(function () {
  var CSS = '.gty-wacb-button{width:56px!important;height:56px!important;min-width:0!important;' +
            'padding:0!important;border-radius:50%!important;display:flex!important;' +
            'align-items:center!important;justify-content:center!important;overflow:hidden!important;' +
            'box-shadow:0 4px 14px rgba(0,0,0,.18)!important}' +
            '.gty-wacb-button > *:not(svg){display:none!important}' +
            '.gty-wacb-button-logo{margin:0!important}';

  function aggiusta() {
    var h = document.querySelector('gty-whatsapp-chat-button');
    if (!h || !h.shadowRoot || h.dataset.ssFatto) return false;
    var s = document.createElement('style');
    s.textContent = CSS;
    h.shadowRoot.appendChild(s);
    h.dataset.ssFatto = '1';
    return true;
  }

  if (!aggiusta()) {
    var n = 0;
    var t = setInterval(function () { if (aggiusta() || ++n > 40) clearInterval(t); }, 400);
  }
})();
